import { KycProcessStatus } from 'further-types/kyc';

export const canResetKyc = (investorKyc?: {
  idvProcessStatus?: KycProcessStatus;
}) => {
  return (
    investorKyc?.idvProcessStatus &&
    investorKyc?.idvProcessStatus !== KycProcessStatus.Reset &&
    investorKyc?.idvProcessStatus !== KycProcessStatus.NotAttempted
  );
};

export const canUnapproveAml = (
  investorKyc?: {
    amlProcessStatus?: KycProcessStatus;
  } | null,
) => {
  return (
    investorKyc?.amlProcessStatus &&
    [KycProcessStatus.AdminApproved, KycProcessStatus.Passed].includes(
      investorKyc.amlProcessStatus,
    )
  );
};

export const canApproveIdv = (
  investorKyc?: {
    idvProcessStatus?: KycProcessStatus;
  } | null,
) => {
  return investorKyc?.idvProcessStatus === KycProcessStatus.Failed;
};

export const canApproveAml = (
  investorKyc?: {
    amlProcessStatus?: KycProcessStatus;
  } | null,
) => {
  return investorKyc?.amlProcessStatus === KycProcessStatus.Failed;
};
